<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="grey--text text-body-1">
            {{ $t("kurikulum.kurikulum").toUpperCase() }} &raquo;
            {{ $t("mk.daftar_mk").toUpperCase() }} &raquo;
            {{ $t("mk.pengampu_mk").toUpperCase() }}
          </div>
        </v-col>
        <br />
        <v-col cols="12" v-for="dt in datasMK" :key="dt.uuid || dt.id">
          <v-card tile elevation="1" class="pa-4 text-body-2">
            <v-chip label color="primary"
              ><b>{{ dt.kode_mata_kuliah }}</b></v-chip
            >
            <table border="0" style="width: 100%; padding-top: 4pt">
              <tr>
                <td style="width: 50%">
                  <span class="primary--text">{{
                    dt.nama_mata_kuliah_id
                  }}</span>
                </td>
                <td style="width: 25%">Jenis mata kuliah</td>
                <td style="width: 25%">: {{ getJenisMataKuliah(dt) }}</td>
              </tr>
              <tr>
                <td>
                  <i>{{ dt.nama_mata_kuliah_en }}</i>
                </td>
                <td>Kategori</td>
                <td>
                  : {{ getKategoriMataKuliah(dt.kategori_mata_kuliah) }}
                </td>
                <!-- <td>Nilai minimum lulus</td>
                <td>: {{ dt.nilai_minimum }}</td> -->
              </tr>
              <tr>
                <td>{{ dt.sks_mata_kuliah }} sks</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Koordinator :
                  <span
                    v-if="
                      isEmpty(dt.koordinator)
                    "
                    >-</span
                  ><span v-else>{{ getKoordinatorName(dt) }}</span>
                </td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </v-card>
          <v-alert text tile class="blue-grey lighten-5"
            ><h4>Deskripsi Mata Kuliah</h4>
            <div class="py-2">
              <span
                v-if="
                  isEmpty(dt.deskripsi_id)
                "
                >Belum ada deskripsi.</span
              ><span v-else>{{ dt.deskripsi_id }}</span>
            </div>
            <v-divider></v-divider>
            <div class="py-2">
              <i
                ><span
                  v-if="
                    isEmpty(dt.deskripsi_en)
                  "
                  >No description yet.</span
                ><span v-else>{{ dt.deskripsi_en }}</span></i
              >
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="datas"
        class="elevation-1"
        item-key="id"
        :search="search"
      >
        <template v-slot:item.nomor="{ item }">
          {{ datas.indexOf(item) + 1 }}
        </template>
        <template v-slot:item.dosen.prodi.nama_prodi_id="{ item }">
          {{ getProgramStudi(item) }}
        </template>
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar dark color="primary">
              <v-toolbar-title>{{ $t("mk.pengampu_mk") }}</v-toolbar-title>
            </v-toolbar>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-model="editedItem.nidn"
                            :items="dosenItems"
                            :rules="rules"
                            item-value="dosen.nidn"
                            :item-text="getDosenText"
                            label="Dosen"
                            clearable
                            single-line
                            dense
                          >
                            <template v-slot:selection="{ item }">
                              {{ getDosenText(item) }}
                            </template>
                            <template v-slot:item="{ item }">
                              {{ getDosenText(item) }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      {{ $t("tabel.batal") }}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      :disabled="!valid"
                      text
                      @click="save"
                    >
                      {{ $t("tabel.simpan") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline">{{
                  $t("tabel.dialog_hapus")
                }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">{{
                    $t("tabel.batal")
                  }}</v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deleteItemConfirm"
                    >{{ $t("tabel.ok") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-text-field
            v-model="search"
            :label="$t('tabel.cari')"
            class="mx-4 pt-4"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small color="warning" class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small color="error" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data> {{ $t("tabel.tidak_ada_data") }} </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "MataKuliahPengampu",
  data: () => ({
    datasMK: [],
    dialog: false,
    dialogDelete: false,
    valid: true,
    search: "",
    datas: [],
    dosenItems: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    kode_semester: null,
    loadingCount: 0,
  }),

  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("tabel.tambah")
        : this.$t("tabel.edit");
    },
    headers() {
      return [
        { text: "No", value: "nomor" },
        { text: "NIDN", value: "nidn" },
        { text: "Nama Dosen", value: "dosen.nama" },
        { text: "Program Studi", value: "dosen.prodi.nama_prodi_id" },
        { text: this.$t("tabel.aksi"), value: "actions", sortable: false },
      ];
    },
    rules() {
      return [(v) => !!v || this.$t("tabel.required")];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      setAlert: "alert/set",
    }),

    authConfig() {
      return {
        headers: {
          Authorization: "Bearer " + this.user.data.token,
        },
      };
    },

    showLoading() {
      if (this.loadingCount === 0) {
        this.$vloading.show();
      }
      this.loadingCount += 1;
    },

    hideLoading() {
      this.loadingCount = Math.max(this.loadingCount - 1, 0);
      if (this.loadingCount === 0) {
        this.$vloading.hide();
      }
    },

    getResponseData(response) {
      var data = response && response.data ? response.data.data : [];
      return Array.isArray(data) ? data : [];
    },

    getErrorMessage(error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return error.response.data.message;
      }
      return "Terjadi kesalahan saat memproses data.";
    },

    showError(error) {
      this.setAlert({
        status: true,
        color: "error",
        text: this.getErrorMessage(error),
      });
    },

    isEmpty(value) {
      return value === "" || value === 0 || value === null || value === undefined;
    },

    getKodeProdiAktif() {
      var aktif = this.user && this.user.data ? this.user.data.aktif : null;
      if (!aktif) {
        return null;
      }
      if (aktif.kode_prodi) {
        return aktif.kode_prodi;
      }
      return aktif.prodi ? aktif.prodi.kode_prodi : null;
    },

    getJenisMataKuliah(mataKuliah) {
      return mataKuliah && mataKuliah.jenis_mk
        ? mataKuliah.jenis_mk.nama_jenis_mk_id || "-"
        : "-";
    },

    getKategoriMataKuliah(kategori) {
      if (this.isEmpty(kategori)) {
        return "-";
      }
      return kategori == "1" ? "MKK" : "MKWU";
    },

    getKoordinatorName(mataKuliah) {
      return mataKuliah && mataKuliah.koordinator
        ? mataKuliah.koordinator.nama || "-"
        : "-";
    },

    getJenjangLabel(jenjang) {
      var labels = {
        A: "S3",
        B: "S2",
        C: "S1",
        D: "D4",
        E: "D3",
        F: "D2",
        G: "D1",
        H: "Sp-1",
        I: "Sp-2",
        J: "PROFESI",
        X: "NON AKADEMIK",
      };
      return labels[jenjang] || "";
    },

    getProgramStudi(item) {
      var prodi = item && item.dosen ? item.dosen.prodi : null;
      if (!prodi) {
        return "-";
      }

      var jenjang = this.getJenjangLabel(prodi.jenjang);
      var namaProdi = prodi.nama_prodi_id || "-";
      return jenjang ? jenjang + " - " + namaProdi : namaProdi;
    },

    getDosenText(item) {
      var dosen = item && item.dosen ? item.dosen : null;
      if (!dosen) {
        return "-";
      }

      var nidn = dosen.nidn || "-";
      var nama = dosen.nama || "-";
      return nidn + " - " + nama;
    },

    buildFormData() {
      var formData = new FormData();
      formData.set("nidn", this.editedItem.nidn);
      formData.set("mata_kuliah_id", this.$route.params.id);
      formData.set("kode_semester", this.kode_semester);
      return formData;
    },

    initialize() {
      this.getMataKuliah();
      this.getMkPengampu();
      this.getDosenProdi();
    },

    getMataKuliah() {
      this.showLoading();
      this.axios
        .get("/api/auth/getMataKuliah/" + this.$route.params.id, this.authConfig())
        .then((response) => {
          var data = this.getResponseData(response);
          var mataKuliah = data[0] || {};
          this.datasMK = data;
          this.kode_semester = mataKuliah.kurikulum
            ? mataKuliah.kurikulum.kode_semester
            : null;
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          this.showError(error);
          this.close();
          this.closeDelete();
        });
    },

    getMkPengampu() {
      this.showLoading();
      this.axios
        .get(
          "/api/auth/getMkPengampuByMk/" + this.$route.params.id,
          this.authConfig()
        )
        .then((response) => {
          this.datas = this.getResponseData(response);
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          this.showError(error);
          this.close();
          this.closeDelete();
        });
    },

    getDosenProdi() {
      this.showLoading();
      this.axios
        .get("/api/auth/hakAksesList", this.authConfig())
        .then((response) => {
          var data = this.getResponseData(response);
          var aktif = this.user.data.aktif || {};
          if (aktif.role == "1") {
            this.dosenItems = data;
          } else {
            var kodeProdi = this.getKodeProdiAktif();
            this.dosenItems = data.filter(
              (e) =>
                e &&
                e.kode_prodi == kodeProdi &&
                e.role == "5"
            );
          }
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          this.showError(error);
          this.close();
          this.closeDelete();
        });
    },

    editItem(item) {
      this.editedIndex = this.datas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.datas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      if (!this.editedItem.id) {
        this.showError();
        this.closeDelete();
        return;
      }

      var id = this.editedItem.id;
      this.closeDelete();
      this.showLoading();
      this.axios
        .delete("/api/auth/destroyMkPengampu/" + id, this.authConfig())
        .then(() => {
          this.hideLoading();
          this.setAlert({
            status: true,
            color: "success",
            text: this.$t("notif.hapus"),
          });
          this.getMkPengampu();
        })
        .catch((error) => {
          this.hideLoading();
          this.showError(error);
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.isEmpty(this.kode_semester)) {
        this.setAlert({
          status: true,
          color: "error",
          text: "Kode semester mata kuliah belum tersedia.",
        });
        return;
      }

      var isEdit = this.editedIndex > -1;
      var endpoint = isEdit
        ? "/api/auth/saveMkPengampu/" + this.editedItem.id
        : "/api/auth/saveMkPengampu";

      this.showLoading();
      this.axios
        .post(endpoint, this.buildFormData(), this.authConfig())
        .then(() => {
          this.hideLoading();
          this.setAlert({
            status: true,
            color: "success",
            text: isEdit ? this.$t("notif.ubah") : this.$t("notif.tambah"),
          });
          this.close();
          this.closes();
          this.getMkPengampu();
        })
        .catch((error) => {
          this.hideLoading();
          this.showError(error);
        });
    },

    closes() {
      this.$emit("closed", false);
    },
  },
};
</script>
